import AdminLayout from '../views/admin/AdminLayout.vue';

const adminRoutes = [
  {
    path: '/lss/admin/login',
    name: 'adminLogin',
    component: () => import('../views/admin/AdminLogin.vue'),
    meta: { title: '管理员登录' }
  },
  {
    path: '/lss/admin',
    component: AdminLayout,
    meta: { requiresAdmin: true },
    redirect: '/lss/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'adminDashboard',
        component: () => import('../views/admin/AdminDashboard.vue'),
        meta: { title: '管理后台 - 仪表盘' }
      },
      {
        path: 'users',
        name: 'adminUsers',
        component: () => import('../views/admin/AdminUsers.vue'),
        meta: { title: '管理后台 - 用户管理' }
      },
      {
        path: 'songs',
        name: 'adminSongs',
        component: () => import('../views/admin/AdminSongs.vue'),
        meta: { title: '管理后台 - 歌曲管理' }
      },
      {
        path: 'accounts',
        name: 'adminAccounts',
        component: () => import('../views/admin/AdminAccounts.vue'),
        meta: { title: '管理后台 - 账号管理' }
      },
      {
        path: 'tasks',
        name: 'adminTasks',
        component: () => import('../views/admin/AdminTasks.vue'),
        meta: { title: '管理后台 - 任务管理' }
      },
      {
        path: 'analytics',
        name: 'adminAnalytics',
        component: () => import('../views/admin/AdminAnalytics.vue'),
        meta: { title: '管理后台 - 行为分析' }
      }
    ]
  }
];

export default adminRoutes;
